import Luiv3Constants from '@app/lui3/constants';
import FaIcon from '@app/lui3/FaIcon';
import FaIconToggle from '@app/lui3/FaIconToggle';
import styled from 'styled-components';

import {useRoamingSettings} from '../RoamingSettingsContext';

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${Luiv3Constants.baseColor['gray-200']};
`;

const InnerWrapper = styled.div`
  padding: 1rem;
  gap: 0.5rem;
  display: flex;
  flex-direction: column;
`;

const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const ToggleHitArea = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;

const Label = styled.div`
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1rem;
  letter-spacing: 0.02em;
  color: ${Luiv3Constants.baseColor['gray-1000']};
`;

const Info = styled.div`
  color: ${Luiv3Constants.baseColor['gray-600']};
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
  letter-spacing: 0.02em;
`;

const Emphasis = styled.span`
  font-weight: 700;
`;

const Banner = styled.div`
  background-color: ${Luiv3Constants.baseColor['gray-50']};
  color: ${Luiv3Constants.baseColor['gray-600']};
  display: flex;
  padding: 0.375rem 0.5rem;
  align-items: center;
  border-radius: 0.625rem;
  font-size: 0.75rem;
  gap: 0.5rem;
`;

const EmailSyncToggle = () => {
  const {emailSyncOnSend, setEmailSyncOnSend} = useRoamingSettings();

  const handleToggle = () => {
    void setEmailSyncOnSend(!emailSyncOnSend);
  };

  const checked = emailSyncOnSend;

  return (
    <div>
      <Divider />
      <InnerWrapper>
        <ToggleWrapper>
          <ToggleHitArea
            role="switch"
            aria-checked={checked}
            tabIndex={0}
            onClick={handleToggle}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                handleToggle();
              }
            }}
          >
            <FaIconToggle checked={checked} onChange={() => {}} />
          </ToggleHitArea>
          <Label>Prompt Me for Email Sync Locations</Label>
        </ToggleWrapper>
        <Info>
          If <Emphasis>On</Emphasis>, you’ll be prompted to choose where to sync
          an email in Loxo after clicking Send.
        </Info>
        <Info>
          If <Emphasis>Off</Emphasis>, emails will only auto-sync to person
          records.
        </Info>
        <Banner>
          <FaIcon icon="circle-info" />
          <div>
            Syncing only applies when an email recipient is already in your Loxo
            database.
          </div>
        </Banner>
      </InnerWrapper>
    </div>
  );
};

export default EmailSyncToggle;
